import ServiceDetailBook from "./ServiceDetailBook";
import ServiceDetailFind from "./ServiceDetailFind";
import ServiceDetailGallery from "./ServiceDetailGallery";
import ServiceDetailHead from "./ServiceDetailHead";
import ServiceDetailPerform from "./ServiceDetailPerform";
import ServiceDetailRange from "./ServiceDetailRange";
import ServiceDetailSlide from "../ServiceDetail/ServiceDetailSlide";
import ServiceDetailStyle from "./ServiceDetailStyle";

export default function ServiceDetail() {

  const imgSlide = [
      { 
        title: 'Style & mood',
        name: 'Lacquered Veneer Finishes',
        para: 'Smooth, refined surfaces available in bold shades and subtle neutrals for a modern modular look.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/modular-split-1.webp',
        imageB: '../image/modular-split-1b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Textured Laminates',
        para: 'Durable, stylish laminates with tactile finishes that balance practicality and elegance.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/modular-split-2.webp',
        imageB: '../image/modular-split-2b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Stone & Solid Shutters',
        para: 'Engineered stone and premium solid tops for kitchens, wardrobes, and integrated modular designs.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/modular-split-3.webp',
        imageB: '../image/modular-split-3b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Customized Wallpaper Shutter',
        para: 'Custom wallpaper-wrapped shutters for a refined, personalized look.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/modular-split-4.webp',
        imageB: '../image/modular-split-4b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Cane Sandwich glass shutter',
        para: 'A timeless touch that adds depth, warmth, and character to your interiors.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/modular-split-5.webp',
        imageB: '../image/modular-split-5b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'PU Paint Finishes',
        para: 'High-quality PU paint finishes for smooth, durable, premium surfaces.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/modular-split-6.webp',
        imageB: '../image/modular-split-6b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Fabric & Leathererrte Finishes',
        para: 'Durable fabric and leatherette options designed for comfort and style.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/modular-split-7.webp',
        imageB: '../image/modular-split-7b.webp',
      },
    ]
    
  return (
    <>
    <ServiceDetailHead/>
    <ServiceDetailFind/>
    <ServiceDetailRange/>
    <ServiceDetailGallery/>
    <ServiceDetailStyle/>
    <ServiceDetailSlide imgSlide={imgSlide}/>
    <ServiceDetailBook/>
    <ServiceDetailPerform/>
    </>
  )
}
